import { render, staticRenderFns } from "./EditStageTournament.vue?vue&type=template&id=0123e258&scoped=true"
import script from "./EditStageTournament.vue?vue&type=script&lang=js"
export * from "./EditStageTournament.vue?vue&type=script&lang=js"
import style0 from "./EditStageTournament.vue?vue&type=style&index=0&id=0123e258&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123e258",
  null
  
)

export default component.exports